import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW9300Model } from '../kymw9300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 「全体向けお知らせ」テーブルの更新を行うサービス
 *
 * @export RegistInformationsService
 * @class RegistInformationsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistInformationsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW9300Model;
  private successFunc: Function;
    vo = {
        loginInformation : '',
        topInformation : ''
    };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
  * bodyにセットする値を返す
  *
  * @private
  * @returns {PlessRequest} リクエストJSON
  * @memberof RegistInformationsService
  */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        ForWholeInfo: {
          condition: {
            LoginInfo: this.vo.loginInformation,
            TopInfo: this.vo.topInformation
          }
        }
      }
    });
　}

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistInformationsService
   */
  execute(model, InformationsVO, successFunc: Function ): void {
    this.model = model;
    this.vo = InformationsVO;
    this.successFunc = successFunc;
    this.send('registInformations', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistInformationsService
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
